import { Box, Typography } from '@mui/material';
import React from 'react';
import _ from 'lodash';
import { IconLock } from 'src/common/images';
import { i18n } from 'src/common/i18n/i18n';

const PrivatePost: React.FC<any> = (props) => {
    const defaultProps = {
        sx: { border: '1px solid black', borderRadius: '8px', overflow: 'hidden', width: '100%', p: 1 },
    };

    return (
        <Box {..._.merge(defaultProps, props)} className="border-color-mlst">
            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                <Box sx={{ position: 'relative', top: '3px' }}>
                    <IconLock style={{ minWidth: 14 }} />
                </Box>
                <Box sx={{ ml: 1 }}>
                    <Typography variant="s14w700">{props.post.body}</Typography>
                    <Typography variant="s12w400">
                        {i18n.translate(
                            "When this happens, it's usually because the owner only shared it with a small group of people, changed who can see it or it's been deleted.",
                        )}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default PrivatePost;
